import { ca } from '@cian/analytics';
import {
  IAnalyticsProduct,
  TAnalyticsOfferStatus,
  TAnalyticsSiteType,
  IAnalyticsExtraOfferIds,
} from '../../types/analytics';
import { EServiceId } from '../../types/reducers/publishTerms';

interface ITrackPublishClickParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  totalPrice: number;
  currentBet: number;
  selectedServiceId: EServiceId;
  offerPosition: number | null;
  page: number | null;
  isAutoprolong: boolean;
  analyticsExtraOfferIds: IAnalyticsExtraOfferIds;
}

export const trackPublishClick = (params: ITrackPublishClickParams) => {
  const {
    analyticsOfferStatus,
    analyticsProduct,
    totalPrice,
    currentBet,
    selectedServiceId,
    offerPosition,
    page,
    isAutoprolong,
    analyticsExtraOfferIds,
  } = params;

  const isPaid = !!totalPrice;
  const publishType = analyticsOfferStatus === 'New_ad' ? 'place' : 'save';
  const payType = isPaid ? 'pay' : null;
  const publishLabel = [publishType, payType].filter(Boolean).join('&');

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'Click',
    label: publishLabel,
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        ...analyticsExtraOfferIds,
        publication_price: totalPrice,
        bid: currentBet,
        vas: selectedServiceId,
        position: offerPosition,
        page_number: page,
        autoprolong: Number(isAutoprolong),
      },
    },
  });
};

interface ITrackPayByCardModalOpenParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsExtraOfferIds: IAnalyticsExtraOfferIds;
}

export const trackPayByCardModalOpen = ({
  analyticsOfferStatus,
  analyticsExtraOfferIds,
}: ITrackPayByCardModalOpenParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'not_enough_money_popup_open',
    label: 'add_offer',
    page: {
      extra: {
        ...analyticsExtraOfferIds,
      },
    },
  });
};

interface ITrackPublishByMoneyFailedParams {
  offerId: number | null;
  siteType: TAnalyticsSiteType;
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsExtraOfferIds: IAnalyticsExtraOfferIds;
}

export const trackPublishByMoneyFailed = (params: ITrackPublishByMoneyFailedParams) => {
  const { offerId, siteType, analyticsOfferStatus, analyticsExtraOfferIds } = params;

  ca('eventSite', {
    name: 'oldEvent',
    category: analyticsOfferStatus,
    action: 'FailedToPublish',
    oid: offerId,
    label: 'not_enough_money',
    page: {
      pageType: 'AddForm',
      siteType,
      extra: {
        ...analyticsExtraOfferIds,
      },
    },
  });
};
